import './webawesome.js';
import '@fontsource-variable/red-hat-display';
import './theme.js';
import './messages.js';
import './sidebar.js';
import './welcome.js';
import './chatbot.js';

// webawesome.js defines every <wa-*> element synchronously on import, so by
// this point the markup is styled and the page can be revealed. html.html.twig
// keeps it hidden until then (with a timeout fallback).
document.documentElement.classList.remove('js-loading');

navigator.serviceWorker?.register('/sw.js');

Drupal.behaviors.eudatDropdownLinks = {
  attach(context) {
    if (context !== document && context !== document.body) {
      return;
    }
    if (window._eudatDropdownLinksBound) {
      return;
    }
    window._eudatDropdownLinksBound = true;

    document.addEventListener('click', (e) => {
      const item = e.target.closest('wa-dropdown-item[href], wa-dropdown-item[data-href]');
      if (item && !item.disabled) {
        const href = item.getAttribute('href') || item.getAttribute('data-href');
        if (href) {
          window.location.href = href;
        }
      }
    });
  },
};
